import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import RenderBlock from '../../components/customer/links/renderBlock';
import Seo from '../components/Seo';

const FAQs = () => {
  const navigate = useNavigate();
  const faqsRaw = useSelector((state) => state.template?.disclaimer?.faqs);
  const { businessPhone, businessEmail } = useSelector((state) => state.configs);

  let decodedContent = null;
  if (faqsRaw) {
    try {
      decodedContent = JSON.parse(faqsRaw);
    } catch (e) {
      decodedContent = null;
    }
  }

  // Geometric background style
  const backgroundStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `
      linear-gradient(135deg, color-mix(in srgb, var(--primary) 3%, transparent) 0%, color-mix(in srgb, var(--primary) 1%, transparent) 100%),
      repeating-linear-gradient(45deg, transparent, transparent 35px, color-mix(in srgb, var(--primary) 2%, transparent) 35px, color-mix(in srgb, var(--primary) 2%, transparent) 70px),
      repeating-linear-gradient(-45deg, transparent, transparent 35px, color-mix(in srgb, var(--primary) 1%, transparent) 35px, color-mix(in srgb, var(--primary) 1%, transparent) 70px)
    `,
    zIndex: -1,
  };

  return (
    <>
      <Seo title="FAQs" description="Frequently asked questions." />
      <Box sx={backgroundStyle} />
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h2" sx={{ fontWeight: 600, fontSize: { xs: '2rem', md: '2.5rem' }, mb: 2 }}>
            Frequently Asked Questions
          </Typography>
        </Box>

        {decodedContent?.blocks?.length > 0 ? (
          <Box sx={{ '& ul': { listStyle: 'disc' } }}>
            {decodedContent.blocks.map((block, index) => (
              <Box key={block.key || index}>{RenderBlock(block, decodedContent)}</Box>
            ))}
          </Box>
        ) : (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography sx={{ color: '#666', mb: 2 }}>No FAQs have been published yet.</Typography>
            <Typography
              onClick={() => navigate('/contact')}
              sx={{ color: 'var(--primary)', cursor: 'pointer', fontWeight: 600 }}
            >
              Contact us with your question
            </Typography>
          </Box>
        )}

        {(businessPhone || businessEmail) && (
          <Box sx={{ mt: 6, p: 4, backgroundColor: '#f5f5f5', borderLeft: '4px solid var(--primary)' }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Still have questions?</Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 3 }}>
              {businessPhone && (
                <Box>
                  <Typography sx={{ fontWeight: 600, color: 'var(--primary)' }}>Call/WhatsApp:</Typography>
                  <Typography>{businessPhone}</Typography>
                </Box>
              )}
              {businessEmail && (
                <Box>
                  <Typography sx={{ fontWeight: 600, color: 'var(--primary)' }}>Email:</Typography>
                  <Typography>{businessEmail}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Container>
    </>
  );
};

export default FAQs;
